import Boat1 from '#/src/static/img/boats/boat1.png';
import Boat2 from '#/src/static/img/boats/boat2.png';
import Boat3 from '#/src/static/img/boats/boat3.png';
import Boat4 from '#/src/static/img/boats/boat4.png';
import Boat5 from '#/src/static/img/boats/boat5.png';
import Boat6 from '#/src/static/img/boats/boat6.png';
import Boat7 from '#/src/static/img/boats/boat7.png';
import Boat8 from '#/src/static/img/boats/boat8.png';
import Boat9 from '#/src/static/img/boats/boat9.png';
import Boat10 from '#/src/static/img/boats/boat10.png';
import Boat11 from '#/src/static/img/boats/boat11.png';
import Boat12 from '#/src/static/img/boats/boat12.png';
import Boat13 from '#/src/static/img/boats/boat13.png';
import Boat14 from '#/src/static/img/boats/boat14.png';

export const BOAT_ICONS_BY_PLACE = {
  1: Boat1,
  2: Boat2,
  3: Boat3,
  4: Boat4,
  5: Boat5,
  6: Boat6,
  7: Boat7,
  8: Boat8,
  9: Boat9,
  10: Boat10,
  11: Boat11,
  12: Boat12,
  13: Boat13,
  14: Boat14,
};
